// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1g2R2","notes":"Notes_notes__3VG_A","note":"Notes_note__3stO7","markdown":"Notes_markdown__29SB3"};